import ChangePassword from "../SecurityCenter/components/ChangePassword";
import ChangePhone from "./components/ChangePhone";
import DeleteAccount from "../SecurityCenter/components/DeleteAccount";

const Account = () => {
  return (
    <div className="grid  gap-5">
      <ChangePhone />
      <ChangePassword />
      <DeleteAccount />
    </div>
  );
};

export default Account;
